export default "__VITE_ASSET__54f026e0__"